__turbopack_context__.v({
  "buttonWrapper": "not-found-module__HS70Aa__buttonWrapper",
  "content": "not-found-module__HS70Aa__content",
  "description": "not-found-module__HS70Aa__description",
  "notFoundContainer": "not-found-module__HS70Aa__notFoundContainer",
  "notFoundImage": "not-found-module__HS70Aa__notFoundImage",
  "title": "not-found-module__HS70Aa__title",
});
